export default __webpack_public_path__ + "static-bigflip/media/offline-online-legal-2.b5ea64f9.webp";